import React, { useState, useEffect } from 'react';
import { Row, Col, FloatingLabel, Tooltip, OverlayTrigger,
  Form, Dropdown, DropdownButton,
  Button, ButtonGroup, Modal } from 'react-bootstrap';
import axios from 'axios';
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useLocation, useParams, useNavigate } from 'react-router-dom';

import category1Icon from '../../dist/images/icons/categories/1.png'
import category2Icon from '../../dist/images/icons/categories/2.png'
import category3Icon from '../../dist/images/icons/categories/3.png'
import category4Icon from '../../dist/images/icons/categories/4.png'
import category5Icon from '../../dist/images/icons/categories/5.png'
import category6Icon from '../../dist/images/icons/categories/6.png'
import category7Icon from '../../dist/images/icons/categories/7.png'
import category8Icon from '../../dist/images/icons/categories/8.png'
import category9Icon from '../../dist/images/icons/categories/9.png'

const App = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const location = useLocation();
  const navigate = useNavigate();
  const {id} = useParams()
  


  
  const isCreatePage = location.pathname.includes('categories/create/') || location.pathname.includes('categories/edit/');

  const [addShow, setAddShow] = useState(false);
  const handleAddClose = () => onCloseFrom();
  const handleAddShow = () => setAddShow(true);

    


  const [categoryName, setCategoryName] = useState("");
  const [CategoryIcon, setCategoryIcon] = useState("");
  const [CategoryType, setCategoryType] = useState("1"); 
  const [error, setError] = useState({});
  const [editId, setEditId] = useState(null)

  const categoryIcons = {
    1: category1Icon,
    2: category2Icon,
    3: category3Icon,
    4: category4Icon,
    5: category5Icon,
    6: category6Icon,
    7: category7Icon,
    8: category8Icon,
    9: category9Icon,
  };

  const onCloseFrom = () => {
    setCategoryName("");
    setCategoryIcon("");
    setCategoryType("1"); 
    setError({});
    setAddShow(false);
    navigate('/categories/', { state: { onFetchData: true } })
    setEditId(null)
  }

  useEffect(() => {
    if(id){
      setEditId(id)
    }
  }, [id])

  useEffect(() => {
    if(isCreatePage || (isCreatePage && editId)){
      setAddShow(true)
    }
    if(isCreatePage && editId){
      fetchEditData()
    }
  }, [isCreatePage, editId])


  const fetchEditData = () => {
    axios.get(`${apiUrl}Category/${editId}`)
    .then(response => {
      // console.log(response.data);
      const data = response.data;
      setCategoryName(data.Category)
      setCategoryIcon(data.Category_img_id)
      setCategoryType(data.Category_type)
    })
    .catch(error => {
      console.error('Error fetching data: ', error,);
    });
  }

  


  const validation = () => {
    const newError = {};
    if (!categoryName.trim()) {
      newError.categoryName = "Category Name is required";
    }
    if (!CategoryIcon) {
      newError.CategoryIcon = "Category Icon is required";
    }
    if (!CategoryType) {
      newError.CategoryType = "Category Type is required"; 
    }
    return newError;
  };

  const handleCreateTemplateSubmit = async (e) => {
    e.preventDefault();
    const validationForm = validation();

    if (Object.keys(validationForm).length > 0) {
      setError(validationForm);
    } else {
      const formData = {
        Category: categoryName,
        Category_img_id: CategoryIcon,
        Category_type: CategoryType, 
      };

      let sendApi = `${apiUrl}/Category/`
      if (editId) {
        sendApi = `${apiUrl}/Category/${editId}`
      }

      const method = editId ? 'put' : 'post';

      axios({
          method: method, 
          url: sendApi,
          data: formData, 
        })
        .then((response) => {
          onCloseFrom()          
          toast.success("Category Data Submitted")

        })
        .catch((error) => {
          toast.warning("Network Issue. Try again later")
          onCloseFrom() 
          console.error("Error submitting form:", error, `${process.env.REACT_APP_API}/Category/`, formData);
        });
    }
  };

  return (
    <>
      <Modal show={addShow} size="lg" onHide={handleAddClose} animation={false} centered>
        <Modal.Body>
          <form onSubmit={handleCreateTemplateSubmit} className="bgWhite p-4" id="myForm">
            <Row>
              <Col xs={12}>
                <h4 className="fw-bold mb-5">Create Category</h4>
                <Form.Group className="mb-4 " controlId="floatingInput">
                  <div className="frm-group"> 
                  <Form.Label>Category name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder=""
                    onChange={(e) => {setCategoryName(e.target.value); error.categoryName = ''}}
                    value={categoryName}
                  />
                  </div>
                  {error.categoryName && <p className="errors mt-2">{error.categoryName}</p>}
                </Form.Group>

                {/* Radio Buttons with Images */}
                <Form.Group className="mb-4">
                  <div className="frm-group">
                  <Form.Label>Category Icon</Form.Label>
                  <div className="d-flex gap-3" style={{flexWrap:"wrap"}}>
                  {Object.entries(categoryIcons)?.map(([id, icon]) => (
                    <Form.Check type="radio" className="radio-image" key={id}>
                      <Form.Check.Input
                        type="radio"
                        name="radioGroup"
                        value={id}
                        checked={CategoryIcon === id}
                        onChange={(e) => {setCategoryIcon(e.target.value); error.CategoryIcon = ''}}
                      />
                      <Form.Check.Label>
                        <img
                          src={icon} // Replace with actual image URL
                          alt={id}
                          className="radio-img"
                        />
                      </Form.Check.Label>
                    </Form.Check>

                  ))}  
                  </div> 
                  </div>

                    
                  {error.CategoryIcon && <p className="errors mt-2">{error.CategoryIcon}</p>}
                </Form.Group>

                {/* Dropdown */}
             <Form.Group className="mb-4">
              <div className="frm-group">
                <Form.Label>Type</Form.Label>
                <Form.Select
                  aria-label="Default select example"
                  className="form-control"
                  value={CategoryType || "Select an option"}  // Ensure CategoryType is defined, or use default value
                  onChange={(e) => setCategoryType(e.target.value)}  // Changed onSelect to onChange
                >
                  <option value="1">Expense</option>
                  <option value="2">Income</option>
                </Form.Select>
              </div>
              {error.CategoryType && <p className="errors">{error.CategoryType}</p>}
            </Form.Group>

                

                <Col md="auto" className="text-end">
                  <button type="submit" className="btn-green my-3">
                    Save
                  </button>
                </Col>
              </Col>
            </Row>
          </form>
          
        </Modal.Body>
      </Modal>
    </>
  );
};

export default App;
